import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CoreDataService } from '../core.data';
import { CustomEncoder } from '../http.util';
import { VersionConfigService } from '@app/core/services/version-config';
import { API } from '@app/core/models';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class ReportsHttpService {
  private _urlPrefix = '';
  private _options: API.HttpOptions;

  constructor(
    private _coreDataService: CoreDataService,
    private _versionConfigService: VersionConfigService,
  ) {
    this._versionConfigService
      .getVersion('reports')
      .subscribe((version: string | undefined) => {
        if (version !== undefined) {
          this._urlPrefix = `${version}/reports`;
        }
      });
    this._options = this._coreDataService.getHttpOptions();
  }

  getPositionDetails(
    hotelId: string,
    startDate: string,
    endDate: string,
  ): Observable<any> {
    const headers = new HttpHeaders();
    const options = {
      headers,
      withCredentials: true,
      params: null,
    };

    options.params = this._coreDataService.generatePlatformQueryParameters(
      new HttpParams({
        encoder: new CustomEncoder(),
      }),
      {
        entid: hotelId,
        startDate,
        endDate,
      },
    );
    return this._coreDataService.get(
      `${this._urlPrefix}/position-details`,
      options,
    );
  }

  getHotelGroupWinLoss(
    hotelId: string,
    startDate: string,
    endDate: string,
  ): Observable<any> {
    const headers = new HttpHeaders();
    const options = {
      headers,
      withCredentials: true,
      params: null,
    };

    options.params = this._coreDataService.generatePlatformQueryParameters(
      new HttpParams({
        encoder: new CustomEncoder(),
      }),
      {
        entid: hotelId,
        startDate,
        endDate,
      },
    );
    return this._coreDataService.get(
      `${this._urlPrefix}/hotel-group-win-loss`,
      options,
    );
  }

  getTeamWellnessChecksHotels(): Observable<API.GetWellnessHotelsSuccess> {
    return this._coreDataService.get<API.GetWellnessHotelsSuccess>(
      `${this._urlPrefix}/team-wellness-checks-hotels`,
      this._options,
    );
  }

  getTeamWellnessCheckInReport(
    entId: string,
    date: string,
  ): Observable<API.GetWellnessCompletionReportSuccess> {
    date = moment(date).format('YYYY-MM-DD');
    const encodedEntId = encodeURIComponent(entId);
    return this._coreDataService.get<API.GetWellnessCompletionReportSuccess>(
      `${this._urlPrefix}/team-wellness-check-in-report/${encodedEntId}/${date}`,
      this._options,
    );
  }
}
